// src/helpers/rutaCarteras.js
import axios from "axios";

const RAW_BASE_URL =
  import.meta.env?.VITE_API_URL ||
  "https://backsanpancracio.us-3.evennode.com";

const BASE_URL = String(RAW_BASE_URL).replace(/\/+$/, "");

const API = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
});

const p = (s) => String(s || "").replace(/^\/+/, "");

// token header: tu back usa "token"
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token") || "";
  if (token) config.headers.token = token;
  return config;
});

const parseErr = (e) =>
  e?.response?.data?.msg ??
  e?.response?.data?.err ??
  e?.response?.data?.error ??
  e?.response?.data?.message ??
  e?.message ??
  "Error desconocido";

/**
 * GET /carteras
 * filtros: tipo, estado, empresa, clienteId
 */
export const getCartera = async ({ tipo, estado, empresa, clienteId, proveedorId } = {}) => {
  try {
    const { data } = await API.get(p("carteras"), {
      params: {
        ...(tipo ? { tipo } : {}),
        ...(estado ? { estado } : {}),
        ...(empresa ? { empresa } : {}),
        ...(clienteId ? { clienteId } : {}),
        ...(proveedorId ? { proveedorId } : {}),
      },
    });
    return data; // { ok, items }
  } catch (e) {
    return { ok: false, msg: parseErr(e), items: [] };
  }
};

export const getCarteraDisponibles = async ({ estados, tipo, cobradoA, pagadoA, empresa, clienteId, proveedorId } = {}) => {
  try {
    const { data } = await API.get(p("carteras/disponibles"), {
      params: {
        ...(estados ? { estados: Array.isArray(estados) ? estados.join(",") : estados } : {}),
        ...(tipo ? { tipo } : {}),
        ...(cobradoA ? { cobradoA } : {}),
        ...(pagadoA ? { pagadoA } : {}),
        ...(empresa ? { empresa } : {}),
        ...(clienteId ? { clienteId } : {}),
        ...(proveedorId ? { proveedorId } : {}),
      },
    });
    return data;
  } catch (e) {
    return { ok: false, msg: parseErr(e), items: [] };
  }
};

export const postCarteraInicial = async (payload) => {
  try {
    const { data } = await API.post(p("carteras/inicial"), payload);
    return data; // { ok, item }
  } catch (e) {
    return Promise.reject(new Error(parseErr(e)));
  }
};

export const putCartera = async (id, payload) => {
  try {
    const url = p(`carteras/${encodeURIComponent(String(id))}`);
    const { data } = await API.put(url, payload);
    return data; // { ok, item }
  } catch (e) {
    return Promise.reject(new Error(parseErr(e)));
  }
};
